<div
	ngClass="p-xxl m-r-xl m-l-xl m-b-l"
	ngClass.lt-md="p-l-m p-r-s p-b-xxl m-b-s  p-t-xxl m-t-s"
	fxFlex="100"
	fxLayout="column"
	fxLayout.lt-sm="row wrap"
	fxLayoutAlign="center"
	fxLayoutGap="2%"
>
	<!--HEADING ROW-->
	<div
		fxFlex="100"
		fxLayout="row"
		fxLayoutAlign="center center"
		ngClass="center"
	>
		<div
			fxFlex="100"
			fxLayout="column"
			fxLayoutAlign="center center"
			ngClass.gt-xs="m-b-xl"
			ngClass.lt-sm="p-b-m"
		>
			<h2
				class="dark-grey-texts"
				i18n="@@features-why_fundraisingFeaturesHomeBoth"
			>
				Fundraising Platform Features
			</h2>
		</div>
	</div>
	<!--END HEADING ROW-->

	<!--FIRST ROW OF FEATURES-->
	<div
		fxFlex="100%"
		fxLayout="row"
		fxLayout.xs="column"
		fxLayoutAlign="space-around start"
		fxLayoutGap="5%"
		fxLayoutGap.xs="3%"
	>
		<!--FIRST COLUMN-->
		<div fxFlex="26%" fxLayout="column">
			<div fxFlex="100%" fxLayout="row">
				<div fxLayout="column" ngClass.lt-sm="m-t-l" fxLayoutGap="3%">
					<div fxLayout="row" fxLayoutGap="3%">
						<img
							height="64px"
							width="64px"
							class="hover-on-svg"
							src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/zeroFeeNew/public"
						/>
						<mat-card-title
							class="p-t-xs dark-grey-texts inc-largetext-height"
							i18n="@@features-why_noPlatformFeeHomeBothSide"
						>
							0% Platform Fee
						</mat-card-title>
					</div>
					<div fxLayout="row">
						<p
							class="dark-grey-texts inc-span-height"
							i18n="@@features-why-zeroFeeContent"
						>
							Whydonate charges 0% platform costs and no subscription costs.
							There are only standard costs for payment processing of iDeal,
							Bancontact, Credit card and Paypal.
						</p>
					</div>
				</div>
			</div>
		</div>
		<!--END FIRST COLUMN-->
		<!--SECOND COLUMN-->
		<div fxFlex="26%" fxLayout="column">
			<div fxFlex="100%" fxLayout="row">
				<div fxLayout="column" ngClass.lt-sm="m-t-l" fxLayoutGap="3%">
					<div fxLayout="row" fxLayoutGap="3%">
						<img
							height="64px"
							width="64px"
							class="hover-on-svg"
							src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/customerSupportNew/public"
						/>
						<mat-card-title
							class="p-t-xs dark-grey-texts inc-largetext-height"
							i18n="@@features-why_customerSupportHome"
						>
							Customer Support
						</mat-card-title>
					</div>
					<div fxLayout="row">
						<p
							class="dark-grey-texts inc-span-height"
							i18n="@@features-why-customerContent"
						>
							Need help? WhyDonate customer service is accessible through chat,
							email, or scheduled telephone appointments. The service operates
							seven days a week, from 9 AM - 5 PM Central European Time (CET).
						</p>
					</div>
				</div>
			</div>
		</div>
		<!--END SECOND COLUMN-->
		<!--THIRD COLUMN-->
		<div fxFlex="26%" fxLayout="column">
			<div fxFlex="100%" fxLayout="row">
				<div fxLayout="column" ngClass.lt-sm="m-t-l" fxLayoutGap="3%">
					<div fxLayout="row" fxLayoutGap="3%">
						<img
							height="64px"
							width="64px"
							class="hover-on-svg"
							src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/globalFundNew/public"
						/>
						<mat-card-title
							class="p-t-xs dark-grey-texts inc-largetext-height"
							i18n="@@features-why-globalFundraising"
						>
							Global Fundraising
						</mat-card-title>
					</div>
					<div fxLayout="row">
						<p
							class="dark-grey-texts inc-span-height"
							i18n="@@features-why-globalFundraisingContent"
						>
							You can use the Whydonate platform or integrate the recurring
							giving form on your own website.
						</p>
					</div>
				</div>
			</div>
		</div>
		<!--END THIRD COLUMN-->
	</div>
	<!--END FIRST ROW OF FEATURES-->

	<!--SECOND ROW OF FEATURES-->
	<div
		fxFlex="100%"
		fxLayout="row"
		fxLayout.xs="column"
		fxLayoutAlign="space-around start"
		fxLayoutGap.gt-xs="5%"
		fxLayoutGap.xs="3%"
	>
		<!--FIRST COLUMN-->
		<div fxFlex="26%" fxLayout="column">
			<div fxFlex="100%" fxLayout="row">
				<div fxLayout="column" ngClass.lt-sm="m-t-l" fxLayoutGap="1%">
					<div fxLayout="row" fxLayoutGap="3%">
						<img
							height="64px"
							width="64px"
							class="hover-on-svg"
							src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/dashboardDonorNew/public"
						/>
						<mat-card-title
							class="p-t-xs dark-grey-texts inc-largetext-height"
							i18n="@@features-why-dashboardDonor"
						>
							Dashboard & Donor Management
						</mat-card-title>
					</div>
					<div fxLayout="row">
						<p
							class="dark-grey-texts inc-span-height"
							i18n="@@features_why_comprehensiveDashboardHome"
						>
							The comprehensive dashboard provides a one-stop view of all your
							fundraisers, donor and payout data.
						</p>
					</div>
				</div>
			</div>
		</div>
		<!--END FIRST COLUMN-->
		<!--SECOND COLUMN-->
		<div fxFlex="26%" fxLayout="column">
			<div fxFlex="100%" fxLayout="row">
				<div fxLayout="column" ngClass.lt-sm="m-t-l" fxLayoutGap="3%">
					<div fxLayout="row" fxLayoutGap="3%">
						<img
							height="64px"
							width="64px"
							class="hover-on-svg"
							src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/donorNetworkNew/public"
						/>
						<mat-card-title
							class="p-t-xs dark-grey-texts inc-largetext-height"
							i18n="@@features-why-donorNetwork"
						>
							Donor Network
						</mat-card-title>
					</div>
					<div fxLayout="row">
						<p
							class="dark-grey-texts inc-span-height"
							i18n="@@features_why_additionToYourNetworkHome"
						>
							In addition to your own network, reach 175,000+ donors and
							100,000+ visitors a month on Whydonate.
						</p>
					</div>
				</div>
			</div>
		</div>
		<!--END SECOND COLUMN-->
		<!--THIRD COLUMN-->
		<div fxFlex="26%" fxLayout="column">
			<div fxFlex="100%" fxLayout="row">
				<div fxLayout="column" ngClass.lt-sm="m-t-l" fxLayoutGap="3%">
					<div fxLayout="row" fxLayoutGap="3%">
						<img
							height="64px"
							width="64px"
							class="hover-on-svg"
							src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/liveMinutesNew/public"
						/>
						<mat-card-title
							class="p-t-xs dark-grey-texts inc-largetext-height"
							i18n="@@features_why_liveWithinMinutesHome"
						>
							Live within minutes
						</mat-card-title>
					</div>
					<div fxLayout="row">
						<p
							class="dark-grey-texts inc-span-height"
							i18n="@@features_why_createAndStartOnlineHome"
						>
							Create an account and start online fundraising within minutes.
						</p>
					</div>
				</div>
			</div>
		</div>
		<!--END THIRD COLUMN-->
	</div>
	<!--END SECOND ROW OF FEATURES-->

	<!--THIRD ROW OF FEATURES-->
	<div
		fxFlex="100%"
		fxLayout="row"
		fxLayout.xs="column"
		fxLayoutAlign="space-around start"
		fxLayoutGap="5%"
		fxLayoutGap.xs="3%"
	>
		<!--FIRST COLUMN-->
		<div fxFlex="26%" fxLayout="column">
			<div fxFlex="100%" fxLayout="row">
				<div fxLayout="column" ngClass.lt-sm="m-t-l" fxLayoutGap="3%">
					<div fxLayout="row" fxLayoutGap="3%">
						<img
							height="64px"
							width="64px"
							class="hover-on-svg"
							src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/directPayoutsNew/public"
						/>
						<mat-card-title
							class="p-t-xs dark-grey-texts inc-largetext-height"
							i18n="@@features_why_directPayoutsComingSoonHome"
						>
							Direct Payouts
						</mat-card-title>
					</div>
					<div fxLayout="row">
						<p
							class="dark-grey-texts inc-span-height"
							i18n="@@features_why_requestImmediatePayoutHome"
						>
							Request an immediate payout of the donations, or wait for the
							automated monthly payout. Whydonate pays out donations to all
							European SEPA countries.
						</p>
					</div>
				</div>
			</div>
		</div>
		<!--END FIRST COLUMN-->
		<!--SECOND COLUMN-->
		<div fxFlex="26%" fxLayout="column">
			<div fxFlex="100%" fxLayout="row">
				<div fxLayout="column" ngClass.lt-sm="m-t-l" fxLayoutGap="1%">
					<div fxLayout="row" fxLayoutGap="3%">
						<img
							height="64px"
							width="64px"
							class="hover-on-svg"
							src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/customizeNew/public"
						/>
						<mat-card-title
							class="p-t-xs dark-grey-texts inc-largetext-height"
							i18n="@@features-why-customizeFundraiser"
						>
							Customise Fundraiser
						</mat-card-title>
					</div>
					<div fxLayout="row">
						<p
							class="dark-grey-texts inc-span-height"
							i18n="@@features-why-customizeFundraiserContent"
						>
							Users can create their own crowdfunding page on your platform
							placing text, video and images.
						</p>
					</div>
				</div>
			</div>
		</div>
		<!--END SECOND COLUMN-->
		<!--THIRD COLUMN-->
		<div fxFlex="26%" fxLayout="column">
			<div fxFlex="100%" fxLayout="row">
				<div fxLayout="column" ngClass.lt-sm="m-t-l" fxLayoutGap="3%">
					<div fxLayout="row" fxLayoutGap="3%">
						<img
							height="64px"
							width="64px"
							class="hover-on-svg"
							src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/securityTrustNew/public"
						/>
						<mat-card-title
							class="p-t-xs dark-grey-texts inc-largetext-height"
							i18n="@@features-why-securityTrust"
						>
							Security & Trust
						</mat-card-title>
					</div>
					<div fxLayout="row">
						<p
							class="dark-grey-texts inc-span-height"
							i18n="@@features_why_donationsAndDataSecureHome"
						>
							Whydonate makes sure your donations and data are secure. The data
							is stored encrypted, and all payments are secured by licensed
							payment institutions.
						</p>
					</div>
				</div>
			</div>
		</div>
		<!--END THIRD COLUMN-->
	</div>
	<!--END THIRD ROW OF FEATURES-->
</div>
